import React, { useState, useEffect } from "react";
import { useApiFetch } from "../utils/apiFetch";

function InputUsuarioAutocomplete({
    idSeleccionado,
    setIdSeleccionado,
    label = "Usuario",
    placeholder = "Ingrese apellido paterno",
    title = "Escriba el apellido paterno para buscar",
    readOnly = false,
    maxLength = 50,
    resetEntrada
}) {
    const [query, setQuery] = useState("");
    const [sugerencias, setSugerencias] = useState([]);
    const apiFetch = useApiFetch();

    useEffect(() => {
        const fetchUsuarios = async () => {
            if (query.length < 2 || readOnly) {
                setSugerencias([]);
                return;
            }
            try {
                const data = await apiFetch("consultar_usuarios.php", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ query })
                });

                if (data.status === "success") {
                    setSugerencias(data.data);
                } else {
                    setSugerencias([]);
                }
            } catch {
                setSugerencias([]);
            }
        };

        fetchUsuarios();
    }, [query, readOnly]);

    // Función para limpiar el id seleccionado del input, desde el padre
    useEffect(() => {
        if (idSeleccionado === null) {
            setQuery("");
        }
    }, [idSeleccionado]);

    useEffect(() => {
        if (resetEntrada) {
            setQuery("");
            setIdSeleccionado(null);
            setSugerencias([]);
        }
    }, [resetEntrada, setIdSeleccionado]);

    return (
        <div className="autocomplete">
            <label>{label}</label>
            <input
                type="text"
                value={query}
                onChange={(e) => {
                    // Convertir a mayúsculas y permitir solo letras + espacios + Ñ
                    const valor = e.target.value.toUpperCase();
                    const filtrado = valor.replace(/[^A-ZÑ\s]/g, "");
                    setQuery(filtrado);
                }}
                placeholder={placeholder}
                title={title}
                readOnly={readOnly}
                maxLength={maxLength}
                style={{ textTransform: "uppercase" }}
            />
            {sugerencias.length > 0 && !readOnly && (
                <ul className="sugerencias">
                    {sugerencias.map((u) => (
                        <li
                            key={u.id_usuario}
                            onClick={() => {
                                setIdSeleccionado(u.id_usuario);
                                setQuery(`${u.a_paterno} ${u.a_materno} ${u.usuario}`.toUpperCase());
                                setSugerencias([]);
                            }}
                        >
                            {u.a_paterno} {u.a_materno} {u.usuario}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}

export default InputUsuarioAutocomplete;